import { useState } from 'react';
import * as bi from 'react-bootstrap-icons';
import { IClientTripSearchBackFull, IClientTripBrief } from '@bustickus/models-client';
import { Button, Flex } from 'components';
import { Icon } from 'shared/components';
import { dateFormat } from 'common/helpers';
import { BackTripCard, NoneBackTrips } from './components';
import './style.scss';

interface IProps {
  value?: IClientTripBrief | null;
  onChange?: (v: IClientTripBrief | null) => void;
  back: IClientTripSearchBackFull;
  departureCityName?: string;
  arrivalCityName?: string;
}

function BackTripsBlock(props: IProps) {
  const [isOpen, setOpen] = useState<boolean>(false);

  const backDate = dateFormat(props.back.date, 'DD.MM.YYYY');

  const handleBackTripClick = (trip: IClientTripBrief) => {
    if (trip.id === props.value?.id) {
      props.onChange?.(null);
    } else {
      props.onChange?.(trip);
      setOpen(false);
    }
  };

  return (
    <Flex
      className='back-trips-cntr-lAH1'
      direction='column'
      gap={10}
    >
      {(isOpen || props.value != null) && (
        <Flex
          justifyContent='space-between'
          className='back-city-header-Mash'
        >
          <Flex gap={5}>
            <span className='city-name-Kansh1d'>{props.arrivalCityName ?? 'Неизвестный город'}</span>
            <Icon>
              <bi.ArrowRight />
            </Icon>
            <span className='city-name-Kansh1d'>{props.departureCityName ?? 'Неизвестный город'}</span>
          </Flex>
          <div className='back-ticket-date-KnahQ'>{backDate.datetime}</div>
        </Flex>
      )}

      {props.back.trips.length === 0 && <NoneBackTrips />}

      {!isOpen && props.value != null && (
        <BackTripCard
          onClick={handleBackTripClick}
          trip={props.value}
          selected
        />
      )}

      {isOpen && (
        <Flex
          direction='column'
          gap={10}
        >
          {props.back.trips.map((x) => (
            <BackTripCard
              key={x.id}
              trip={x}
              selected={x.id === props.value?.id}
              onClick={handleBackTripClick}
            />
          ))}
        </Flex>
      )}

      {(props.back.trips.length > 1 || (props.value == null && props.back.trips.length > 0)) && (
        <Button
          className='another-back-trips-btn-Mahs'
          size='small'
          color='transparent-blue'
          onClick={() => setOpen(!isOpen)}
        >
          <Flex gap={5}>
            <Icon>{isOpen ? <bi.CaretUp /> : <bi.CaretDown />}</Icon>
            <span>{isOpen && 'Свернуть'}</span>
            <span>{!isOpen && props.value == null && 'Показать обратные рейсы'}</span>
            <span>{!isOpen && props.value != null && 'Другие обратные рейсы'}</span>
          </Flex>
        </Button>
      )}
    </Flex>
  );
}

export default BackTripsBlock;
